import React from 'react'
import { useSelector } from 'react-redux'
import { PotentialProvider } from './PotentialContext/PotentialContext';
import { DashboardContainer } from '../../funcs/utils';
import { TITLE_POTENTIAL } from '../../constants/constants';
import Potential from './Potential/Potential';

const PotentialDashboard = ({username, args: { acct_index: accountIndex} }) => {
    // redux states
    const client = useSelector(state => state.client);
    const { width, height, device } = useSelector(state => state.app);

    return (
        <DashboardContainer
            client={client}
            device={{ width, height, device }}
            title={TITLE_POTENTIAL}
        >
            <PotentialProvider username={username} accountIndex={accountIndex}>
                <div style={{marginBottom: '24px'}} >{"Edit your values to see how your returns may vary"}</div>
                <Potential />
            </PotentialProvider>
        </DashboardContainer>
    )
}

export default PotentialDashboard;